import { combineEpics } from 'redux-observable';
import { closePriceFilteringBeforeRemoveEpic } from './_epics/closePriceFilteringBeforeRemove.epic';
import { closePriceFilteringSidebarEpic } from './_epics/closePriceFilteringSidebar.epic';
import { reloadPriceFilteringListEpic } from './_epics/reloadPriceFilteringList.epic';
import { toggleViewPriceFilteringSidebarEpic } from './_epics/toggleViewPriceFilteringSidebar.epic';

export const controllerPriceFilteringEpic = combineEpics(
  closePriceFilteringBeforeRemoveEpic,
  closePriceFilteringSidebarEpic,
  reloadPriceFilteringListEpic,
  toggleViewPriceFilteringSidebarEpic,
);
